var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMailSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66797 4.75C3.97761 4.75 3.41797 5.30964 3.41797 6V18C3.41797 18.6904 3.9776 19.25 4.66797 19.25H11.668C12.0822 19.25 12.418 19.5858 12.418 20C12.418 20.4142 12.0822 20.75 11.668 20.75H4.66797C3.14919 20.75 1.91797 19.5188 1.91797 18V6C1.91797 4.48122 3.14919 3.25 4.66797 3.25H20.668C22.1868 3.25 23.418 4.48122 23.418 6V12C23.418 12.4142 23.0822 12.75 22.668 12.75C22.2538 12.75 21.918 12.4142 21.918 12V6C21.918 5.30964 21.3583 4.75 20.668 4.75H4.66797Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6376 14.4697C19.9305 14.1768 20.4054 14.1768 20.6983 14.4697L23.1983 16.9697C23.4912 17.2626 23.4912 17.7374 23.1983 18.0303L20.6983 20.5303C20.4054 20.8232 19.9305 20.8232 19.6376 20.5303C19.3447 20.2374 19.3447 19.7626 19.6376 19.4697L20.8573 18.25H15.168C14.7538 18.25 14.418 17.9142 14.418 17.5C14.418 17.0858 14.7538 16.75 15.168 16.75H20.8573L19.6376 15.5303C19.3447 15.2374 19.3447 14.7626 19.6376 14.4697Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02026 7.62222C6.22897 7.26443 6.68821 7.14358 7.046 7.35229L12.0383 10.2645C12.0383 10.2645 12.0383 10.2645 12.0383 10.2645C12.4274 10.4914 12.9087 10.4915 13.2979 10.2645C13.2979 10.2645 13.2979 10.2645 13.2979 10.2645L18.2902 7.35229C18.648 7.14358 19.1072 7.26443 19.3159 7.62222C19.5246 7.98 19.4038 8.43924 19.046 8.64795L14.0537 11.5602C13.1975 12.0596 12.1387 12.0596 11.2825 11.5602L6.29019 8.64795C5.9324 8.43924 5.81155 7.98 6.02026 7.62222Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailSend);
export default __webpack_public_path__ + "static/media/ic-mail-send.07447e17e411fccb1e07e41aca11facf.svg";
export { ForwardRef as ReactComponent };